import { render, staticRenderFns } from "./NpRecognitionCategoryList.vue?vue&type=template&id=4d0c4760"
import script from "./NpRecognitionCategoryList.vue?vue&type=script&lang=js"
export * from "./NpRecognitionCategoryList.vue?vue&type=script&lang=js"
import style0 from "./NpRecognitionCategoryList.vue?vue&type=style&index=0&id=4d0c4760&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports